import { ItemList, WithContext } from 'schema-dts';
import { Entity } from '~/lib/data-contract/auto-generated/loop54-api-model';
import { Loop54Product } from '~/services/loop54/types';

const WEBSITE_URL = process.env.NEXT_PUBLIC_WEBSITE_URL;

export function itemListSchema(props: ItemListProps): WithContext<ItemList> | undefined {
    const loopItems = (props.items as Loop54Product[])
        ?.flatMap((item) => item.ItemUrl)
        .filter((item) => item);
    const entityItems = (props.items as Entity[])
        ?.flatMap(
            (item) =>
                item?.attributes?.filter((attribute) => attribute.name === 'ItemUrl')?.[0]?.values,
        )
        .filter((item) => item);
    const items = entityItems?.length ? entityItems : loopItems;

    if (!items || !WEBSITE_URL) return;

    return {
        '@context': 'https://schema.org',
        '@type': 'ItemList',
        numberOfItems: items.length,
        itemListElement: items.map((item, index) => {
            return {
                '@type': 'ListItem',
                position: index,
                url: WEBSITE_URL + item,
            };
        }),
    };
}

export interface ItemListProps {
    items?: Loop54Product[] | Entity[];
}
